import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import {
  faLock,
  faPen,
  faSortDown,
  faSortUp,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mpro-dropdown-item',
  templateUrl: './dropdown-item.component.html',
  styleUrls: ['./../dropdown-item.scss', './dropdown-item.component.scss'],
  host: {
    '[class.disabled]': 'disabled',
    '[class.selected]': 'selected',
    '[class.readonly]': 'readonly',
    '(click)': 'onWholeItemClick();',
  },
})
export class DropdownItemComponent {
  public faPen = faPen;
  public faTrash = faTrash;
  public faLock = faLock;
  public faSortDown = faSortDown;
  public faSortUp = faSortUp;

  @Input() public dropdownOpen: boolean;

  @Input() public disabled: boolean;
  @Input() public readonly: boolean = false;
  @Input() public arrow: boolean = false;
  @Input() public showLock: boolean = false;
  @Input() public actions: boolean;
  @Input() public isDropdown: boolean;
  @Input() public leftText: string;
  @Input() public middleText?: string;
  @Input() public selected: boolean = false;

  @Output() public itemClicked: EventEmitter<string> = new EventEmitter();
  @Output() public editClicked: EventEmitter<void> = new EventEmitter();
  @Output() public deleteClicked: EventEmitter<void> = new EventEmitter();
  @Output() public arrowClicked: EventEmitter<boolean> = new EventEmitter();

  @HostBinding('style.--bgColor') @Input() public bgColor?: string;
  @HostBinding('style.--bgColorHover') @Input() public bgColorHover?: string;

  public onWholeItemClick() {
    if (this.disabled) {
      return;
    }
    this.itemClicked.emit();
  }

  public onEditClick(event: any) {
    if (this.disabled) {
      return;
    }
    this.editClicked.emit();
  }

  public onDeleteClick(event: any) {
    if (this.disabled) {
      return;
    }
    this.deleteClicked.emit();
  }

  public onArrowClick(event: any) {
    if (this.disabled) {
      return;
    }
    this.dropdownOpen = !this.dropdownOpen;
    this.arrowClicked.emit(this.dropdownOpen);
  }
}
